import { render, staticRenderFns } from "./AppointmentScheduleAndCompanion.vue?vue&type=template&id=02bcb238"
import script from "./AppointmentScheduleAndCompanion.vue?vue&type=script&lang=js"
export * from "./AppointmentScheduleAndCompanion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports